module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-main column subview-container client"
  }, [(_vm.user) ? _c('div', {
    staticClass: "sub-page column"
  }, [_c('section', {
    staticClass: "details-bar column activity-container container-background"
  }, [_c('div', {
    staticClass: "row container activity-container"
  }, [_c('div', {
    staticClass: "row avatar"
  }, [_c('div', {
    staticClass: "ctn-back",
    on: {
      "click": _vm.goBack
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.client.picture,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold details-bar-username"
  }, [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name))]), _vm._v(" "), _c('div', [_vm._v("Client de "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(((_vm.client.main_advisor.first_name) + " " + (_vm.client.main_advisor.last_name))))]), _vm._v(" chez "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.user.office.name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row infos"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label bold"
  }, [_vm._v("E-MAIL")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label bold"
  }, [_vm._v("TELEPHONE")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.user.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label bold"
  }, [_vm._v("ADRESSE")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.user.address))])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta"
  }, [_c('div', {
    staticClass: "btn btn-grey",
    on: {
      "click": function($event) {
        _vm.showClientModal = true
      }
    }
  }, [_vm._v("\n                      Editer\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "toggle"
  }, [_c('toggle-input', {
    attrs: {
      "value": _vm.user.enabled
    },
    on: {
      "change": _vm.updateClientStatus
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "contentrow row"
  }, [_c('div', {
    staticClass: "inner-row row"
  }, [_c('div', {
    staticClass: "half infos"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "boding column"
  }, [_c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(" Nom complet ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(" " + _vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Date de naissance")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.user.birthdate))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Téléphone")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.user.phone || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Adresse mail")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.user.email || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Adresse postal")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.user.address || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Ville")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.user.city || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Code postal")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.user.zipcode || '-'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "half infos patrimoine column"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "boding column"
  }, [(!_vm.estate.success) ? _c('div', {
    staticClass: "no-patrimoine empty column"
  }, [_vm._v("\n                Votre client doit remplir "), _c('br'), _vm._v("\n                son Paysage Patrimonial pour "), _c('br'), _vm._v("\n                pouvoir commencer à investir.\n                ")]) : _c('div', {
    staticClass: "patrimoines take-place"
  }, [_c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Age")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.user.birthdate || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Métier")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.user.job || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("CSP")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.user.professional_category || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "row info"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Enfants")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.user.kids.length) + " à charge")])]), _vm._v(" "), _c('div', {
    staticClass: "info row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Revenu annuel")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.private_estate_totals.total_incomes || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "info row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Immobilier")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.private_estate_totals.immobilier || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "info row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Epargne")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.private_estate_totals.total_savings || '-'))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "half column appointment"
  })]), _vm._v(" "), _c('baseModal', {
    attrs: {
      "data": _vm.userModal,
      "show": _vm.showClientModal,
      "content": _vm.contentModal
    },
    on: {
      "close": function($event) {
        _vm.showClientModal = false
      }
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading row"
  }, [_c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-info"
  }), _vm._v("\n                Informations\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading row"
  }, [_c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-fiche-client-paysage"
  }), _vm._v("\n                Paysage Patrimonial\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "add row"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-278c5726"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Clients/details/Details.vue
// module id = 624
// module chunks = 1